// import { Link } from 'react-router-dom';
// import Typography from '../common/typography/Typography';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cx from "./footer.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { hTractionMain } from 'src/assets/images';
import { FaXTwitter, FaYoutube, FaInstagram } from "react-icons/fa6";
import { FaFacebookSquare, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate()
  function goToHome() {
    navigate('/')
  }
  return (
    // <div className="footer">
    //   <Typography variant="body-1" fontWeight="semiBold">
    //     <div className='btnarea'>
    //       <Link to="/feedback">Feedback</Link>
    //     </div>
    //     Copyright © 2024 htraction All rights reserved
    //   </Typography>
    // </div>
    <footer className={`${cx.footerMain}`}>
      <Container>
        <Row >
          <Col md={12}>
            <div className={`${cx.footerBorder}`}></div>
          </Col>
          <Col md={4}>
            <div className={`${cx.footerLogo}`}>
              <img src={hTractionMain} alt="logo" onClick={goToHome} />
            </div>
          </Col>
          <Col md={2}></Col>
          <Col md={6}>
            <Row>
              <Col md={6} xs={6}>
                <div className={`${cx.footerList}`}>
                  <h3>Company</h3>
                  <ul>
                    <li>
                      <NavLink className={`${cx.btns}`} to={'/privacy-policy'}>Privacy Policy</NavLink>
                    </li>
                    <li>
                      <NavLink className={`${cx.btns}`} to={'/payment-policy'}>Payment and Refund Policy</NavLink>
                    </li>
                    <li>
                      <NavLink className={`${cx.btns}`} to={'/contact-us'}>Contact Us</NavLink>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={6} xs={6}>
                <div className={`${cx.footerList}`}>
                  <h3>Join Us</h3>
                  <ul>
                    <li>
                      <NavLink className={`${cx.btns}`} to={"/sign-up"}>Entrepreneur</NavLink>
                    </li>
                    <li>
                      <NavLink className={`${cx.btns}`} to={"/investor-login"}>Investor</NavLink>
                    </li>
                  </ul>
                </div>
              </Col>
              {/* <Col md={4} xs={6}>
                <div className={`${cx.footerList}`}>
                  <h3>Resources</h3>
                  <ul>
                    <li>
                      <a className={`${cx.btns}`} href={`https://castling.in/blogs`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >Insights</a>
                    </li>
                    <li>
                      <NavLink className={`${cx.btns}`} to={"#"}>Discover</NavLink>
                    </li>
                  </ul>
                </div>
              </Col> */}
            </Row>
          </Col>
          <Col md={12}>
            <div className={`${cx.footerBottom}`}>
              <p>htraction. All Rights Reserved. © 2025 </p>
              <ul>
                <li>
                  <a href="https://www.linkedin.com/company/htraction"
                    target="_blank"
                    rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/htraction/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/people/Htraction/61567720043681"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookSquare />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@htraction"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube />
                  </a>
                </li>
                <li>
                  <a href="https://x.com/htraction"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaXTwitter />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
